export const ItemHeadingAside: React.FC = ({ children }) => {
  return (
    <>
      <span className="text-inactive mr-5">( </span>
      <span className="text-secondary">{children}</span>
      <span className="text-inactive ml-5"> )</span>
    </>
  );
};
